module.exports = __webpack_public_path__ + "static/media/searchRemoveIcon.be4a6d7a.svg";